/*
 * Runtime copy of site data. Starts as the compiled-in defaults from site.js
 * and is overlaid with published CMS content by SiteContext once
 * /api/public/content arrives. Library helpers (contact, schema, seo) read
 * from here so CMS-updated business details take effect without a rebuild.
 */
import { BUSINESS, PACKAGES, ADDONS, PLANS, CITIES, SERVICE_PAGES, FAQS, SITE_URL } from './site';

export const runtime = {
  SITE_URL,
  BUSINESS: { ...BUSINESS },
  PACKAGES, ADDONS, PLANS, CITIES, SERVICE_PAGES, FAQS,
  PROMOTIONS: [], TESTIMONIALS: [], PAGES: [],
  HOME_SECTIONS: [], NAV_HEADER: [], NAV_FOOTER: [], SEO: []
};

export const applyContent = (cms) => {
  if (!cms) return;
  const pick = (key, fallback) => (Array.isArray(cms[key]) && cms[key].length ? cms[key] : fallback);
  runtime.PACKAGES = pick('packages', PACKAGES);
  runtime.ADDONS = pick('addons', ADDONS);
  runtime.PLANS = pick('plans', PLANS);
  runtime.CITIES = pick('cities', CITIES);
  runtime.SERVICE_PAGES = pick('servicePages', SERVICE_PAGES);
  runtime.FAQS = pick('faqs', FAQS);
  runtime.PROMOTIONS = cms.promotions || [];
  runtime.TESTIMONIALS = cms.testimonials || [];
  runtime.PAGES = cms.pages || [];
  runtime.HOME_SECTIONS = cms.homeSections || [];
  runtime.NAV_HEADER = cms.navItems?.filter((n) => n.menu === 'header') || [];
  runtime.NAV_FOOTER = cms.navItems?.filter((n) => n.menu !== 'header') || [];
  runtime.SEO = cms.seo || [];
  if (cms.settings?.business) runtime.BUSINESS = { ...BUSINESS, ...cms.settings.business };
  return runtime;
};
